/* eslint-disable */
import Events from '@/events'
import {RXJSCache} from "@/data-services/cache/rxjs-cache";
import {getLoadListV3} from "@/api/dispatch";


class LoadServiceV2 {
  constructor(rootVue) {
    this._listCache = new RXJSCache({
      func: getLoadListV3,
      events: [Events.EDIT_LOADS, Events.NEW_LOADS, Events.DELETE_LOADS],
      cacheCount: 10,
      formatResult: true,
      name: 'loadServiceV2List',
      // itemCache: true,
      // getKeyFromEvent: (data) => data,
      // getKeyFromArgs: params => params,
      $bus: rootVue
    })
  }
  get list() {
    return this._listCache
  }
}

let instance = null

export function loadServiceV2ServerInit($bus) {
  console.debug('loadServiceV2ServerInit')
  if(!instance) {
    instance = new LoadServiceV2($bus)
  }
}

export function getLoadServiceV2Instance() {
  return instance
}

